/**
 * Retry / timeout recovery for transient media failures.
 * Does not own playback — callers supply retry callbacks.
 */
export function ErrorRecoveryService(options) {
  options = options || {};
  this.maxRetries = options.maxRetries != null ? options.maxRetries : 3;
  this.retryDelayMs = options.retryDelayMs != null ? options.retryDelayMs : 1200;
  this.attempts = 0;
  this._timer = null;
}

ErrorRecoveryService.prototype.reset = function () {
  this.attempts = 0;
  this.cancel();
};

ErrorRecoveryService.prototype.cancel = function () {
  if (this._timer) {
    clearTimeout(this._timer);
    this._timer = null;
  }
};

/**
 * @param {function(): Promise<boolean>} retryFn resolves true if recovered
 * @returns {Promise<boolean>}
 */
ErrorRecoveryService.prototype.scheduleRetry = function (retryFn) {
  var self = this;
  this.cancel();

  if (this.attempts >= this.maxRetries) {
    return Promise.resolve(false);
  }

  this.attempts += 1;
  var delay = this.retryDelayMs * this.attempts;

  return new Promise(function (resolve) {
    self._timer = setTimeout(function () {
      self._timer = null;
      Promise.resolve()
        .then(function () {
          return retryFn();
        })
        .then(function (ok) {
          resolve(!!ok);
        })
        .catch(function () {
          resolve(false);
        });
    }, delay);
  });
};

export default ErrorRecoveryService;
